<template>
  <div class="negociacoes-container">
    <h2 class="negociacoes-title">Formas de Negociação</h2>
    <v-row dense>
      <v-col
        v-for="(negociacao, index) in negociacoes"
        :key="index"
        cols="12"
        md="6"
        lg="3"
        class="negociacao-item"
      >
        <v-icon
          :size="32"
          :color="'primary'"
          class="negociacao-icon"
        >
          {{ negociacao.icone }}
        </v-icon>
        <span
          class="negociacao-texto"
        >
          {{ negociacao.texto }}
        </span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "NegociacoesComponent",
  props: {
    negociacoes: {
      type: Array,
      required: true,
      default: () => [
        { icone: "mdi-handshake", texto: "Aceita Negociar"},
        { icone: "mdi-home-export-outline", texto: "Aceita Imóvel"},
        { icone: "mdi-car", texto: "Aceita Veículo"},
      ],
    },
  },
};
</script>

<style scoped>
.negociacoes-container {
  width: 100%;
  margin: 2rem auto;
  padding: 0;
  max-width: 1400px;
}

.negociacoes-title {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 2rem;
  color: var(--v-primary-base);
  padding: 0 1rem;
  text-align: left;
  letter-spacing: -0.5px;
  line-height: 1.2;
}

.negociacao-item {
  display: flex;
  align-items: center;
  margin-bottom: 1.25rem;
  padding: 0 1rem;
  justify-content: flex-start;
  transition: opacity 0.3s ease;
}

.negociacao-icon {
  margin-right: 1.25rem;
}

.negociacao-texto {
  font-size: 1.1rem;
  color: var(--v-secondary-base);
  font-weight: 500;
  text-align: left;
  letter-spacing: 0.25px;
  line-height: 1.5;
}

.negociacao-desativada {
  opacity: 0.5;
}

.texto-desativado {
  color: var(--v-grey-base);
}

@media (max-width: 600px) {
  .negociacoes-container {
    margin: 1.5rem auto;
  }

  .negociacoes-title {
    font-size: 1.75rem;
    margin-bottom: 1.5rem;
  }

  .negociacao-texto {
    font-size: 1rem;
  }
}
</style>
